module.exports = __webpack_public_path__ + "img/testImage6.5ee8d3d9.5ee8d3d9.png";